import TournamentsPage from '../components/TournamentsPage';
// import { Helmet } from "react-helmet";
// TODO: reimplement react helmet, use example in Tumble Delivery Website

function Tournaments() {

  return (
    <TournamentsPage />
  );
}

export default Tournaments;